/**
 * Environment configuration for OLI Word Add-in
 *
 * Priority: runtime env (window.__ENV__) > build-time (DefinePlugin) > defaults
 *
 * The gateway API key is not here on purpose: the server-side proxy adds it
 * (Caddy in production, webpack-dev-server in dev), so it never reaches the browser.
 */

// Runtime env injected by Docker entrypoint (env-config.js)
declare global {
  interface Window {
    __ENV__?: {
      OLI_GATEWAY_URL?: string;
    };
  }
}

// Build-time constants replaced by DefinePlugin
declare const __OLI_GATEWAY_URL__: string | undefined;

// Runtime env takes priority over build-time
const OLI_GATEWAY_URL =
  window.__ENV__?.OLI_GATEWAY_URL !== undefined
    ? window.__ENV__.OLI_GATEWAY_URL
    : typeof __OLI_GATEWAY_URL__ !== "undefined"
      ? __OLI_GATEWAY_URL__
      : "https://gateway.oliveiraeolivi.cloud";

// Debug: log config values at runtime
console.log("[Config] OLI_GATEWAY_URL:", OLI_GATEWAY_URL || "(empty - using relative URLs)");

export const config = {
  // OLI Gateway (central API for all services)
  gateway: {
    baseUrl: OLI_GATEWAY_URL,
  },

  // App metadata for analytics
  app: {
    name: "oli-word",
    version: "0.1.0",
  },
} as const;
